"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetricId = exports.Metric = exports.EGranularity = void 0;
const Base_1 = require("./Base");
const Common_1 = require("./Common");
const index_1 = require("../index");
var EGranularity;
(function (EGranularity) {
    EGranularity["DAY"] = "day";
    EGranularity["WEEK"] = "week";
    EGranularity["MONTH"] = "month";
    EGranularity["YEAR"] = "year";
})(EGranularity || (exports.EGranularity = EGranularity = {}));
;
class Metric extends Base_1.Base {
    year = null;
    month = null;
    dayOfMonth = null;
    week = null;
    dayOfWeek = null;
    dayOfYear = null;
    categories = [];
    ids = [];
    value = 0;
    valueMap = {};
    constructor(data, olMap) {
        super('metrics', null);
        (0, Common_1.setObjectProperties)(this, data, olMap, Metric);
        if (!this.id && this.categories && this.year) {
            this.id = getMetricId(this);
        }
    }
    async save(parent) {
        // All the identifiers must be set by calling application
        if (!this.id) {
            this.id = getMetricId(this);
        }
        if (!this.id) {
            throw `Metric ids not set. Cannot save.`;
        }
        if (!this.date) {
            // Derive a date from the year/month/day properties.
            let d = new Date();
            if (this.year) {
                d.setFullYear(Number(this.year));
            }
            if (this.month) {
                d.setMonth(Number(this.month));
            }
            if (this.dayOfMonth) {
                d.setDate(Number(this.dayOfMonth));
            }
            this.date = d.valueOf();
        }
        return super.save(parent);
    }
}
exports.Metric = Metric;
function getMetricId(obj) {
    if (obj.ids?.length) {
        return ['year', 'month', 'dayOfMonth', 'week', 'dayOfWeek', 'dayOfYear'].map(prop => {
            return obj[prop] || '';
        }).concat(obj.ids).join('-');
    }
    else {
        return '';
    }
}
exports.getMetricId = getMetricId;
index_1.olm.metrics = (ref, map) => {
    return new Metric(ref, map);
};
